import tw from 'tailwind-styled-components'

export default tw.a`
  text-indigo-500
  hover:text-indigo-400
  dark:text-indigo-300
  dark:hover:text-indigo-200
`
